// extracted by mini-css-extract-plugin
export default {"buyBtn":"BuyBtn_buyBtn__ug0bz","buyBtnFirstCard":"BuyBtn_buyBtnFirstCard__Ci75Y"};